import { useEffect, useState } from 'react'
import { Switch } from '@headlessui/react'
import { useSelector } from "react-redux";
import { selectUserRole } from "../../../../common/authenticateDashboard/authSlice";
import { hasPermission } from "../../../../common/rbac/roles";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function ToggleSwitch({ nudgeData, customizeState, setCustomizeState }) {
    const [enabled, setEnabled] = useState(false)
    const userRole = useSelector(selectUserRole);
    const canEdit = hasPermission(userRole, 'EDIT_NUDGES');

  useEffect(() => {
    if (nudgeData) {
      const { status:nudgeStatus } = nudgeData?.nudgeShowing?.customizeProperties
      if (nudgeStatus) {
          const { propertyValue } = nudgeStatus
          if(propertyValue==='ON') setEnabled(true)
      }  
    }
    },[nudgeData])


    useEffect(() => {
        let local_status = {};
        if (enabled) {
            local_status = {
                ...customizeState,
                nudgeShowing: {
                    ...customizeState['nudgeShowing'],
                    status: 'ON',
                }
            }
        } else {
            local_status = {
                ...customizeState,
                nudgeShowing: {
                    ...customizeState['nudgeShowing'],
                    status: 'OFF',
                }
            }
        }

        setCustomizeState(local_status)
    }, [enabled])

    // const toggleHandler = () => {
    //     setEnabled((prev) => !prev);
    // }

  return (
    <Switch
      checked={enabled}
      onChange={setEnabled}
      disabled={!canEdit}
    //   onChange={toggleHandler}
      className={classNames(
        enabled ? 'bg-green-600 ring-green-600' : 'bg-red-500 ring-red-600',
        !canEdit ? 'opacity-50 cursor-not-allowed' : '',
        'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2  focus:ring-offset-2'
      )}
      >
          
          <span className="sr-only">Use setting</span>
          
      <span
        aria-hidden="true"
        className={classNames(
          enabled ? 'translate-x-5' : 'translate-x-0',
          'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
        )}
      />
    </Switch>
  )
}


export default ToggleSwitch;